import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <span
    className={`font-mono-tech text-xs uppercase tracking-[0.25em] text-[#00C8D7] ${className}`}
  >
    {children}
  </span>
);
